import { ehFamiliaSaida } from '../shared/checklist-familias';

/**
 * at-96: `REPARO`/`RETORNO` saíram (0 sessões em prod e em dev) e entraram os dois tipos de
 * pós-evento — o retorno de garantia.
 *
 * 🔴 A família de um tipo se decide por `src/shared/checklist-familias.ts`, NUNCA por
 * `type !== 'SAIDA'`: com dois tipos de saída, essa expressão classifica a saída de pós-evento
 * como entrada, sem quebrar tipo, build nem teste.
 */
export type ChecklistType = 'ENTRADA' | 'SAIDA' | 'POS_EVENTO_ENTRADA' | 'POS_EVENTO_SAIDA';

export type MediaCategory = 'ANGLES' | 'SERVICE' | 'CUSTOM';

export type ChecklistTab = 'ANGLES' | 'SERVICE' | 'ITEMS';

/** Estruturas dinâmicas vindas de GET /checklists/config (geridas pelo ADMIN). */
export interface ChecklistAngleConfig {
  id: string;
  key: string;
  label: string;
  helpText?: string | null;
  sortOrder: number;
}

export interface ChecklistCategoryConfig {
  id: string;
  key: string;
  label: string;
  sortOrder: number;
  items: Array<{ key: string; label: string; order: number }>;
}

export interface ChecklistPermissions {
  canEditItems: boolean;
  canEditMedia: boolean;
}

export interface ChecklistConfig {
  angles: ChecklistAngleConfig[];
  categories: ChecklistCategoryConfig[];
  permissions: ChecklistPermissions;
}

export const mediaCategoryLabel: Record<MediaCategory, string> = {
  ANGLES: 'Ângulos',
  SERVICE: 'Imagens de saída',
  CUSTOM: 'Seções personalizadas',
};

export const checklistTabLabel: Record<ChecklistTab, string> = {
  ANGLES: 'Fotos',
  SERVICE: 'Imagens de saída',
  ITEMS: 'Itens',
};

/**
 * Rótulos das TELAS INTERNAS (at-96).
 *
 * ⚠️ Vocabulário diferente do que o associado lê: no PDF e na tela pública os tipos de
 * pós-evento saem como "retorno de garantia", e esses rótulos vêm do BACKEND — não recriar a
 * tradução aqui, senão as duas divergem no primeiro ajuste.
 */
export const checklistTypeLabel: Record<ChecklistType, string> = {
  ENTRADA: 'Entrada',
  SAIDA: 'Saída',
  POS_EVENTO_ENTRADA: 'Entrada de pós-evento',
  POS_EVENTO_SAIDA: 'Saída de pós-evento',
};

/** at-96: por FAMÍLIA — a aba de imagens de saída vale para os dois tipos de saída. */
export const isServiceVisible = (type: ChecklistType) => ehFamiliaSaida(type);
